import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color, strokeWidth, opacity }) => (
  <path
    d="M20.25 7.83331H17.25V4.83331C17.25 4.43549 17.092 4.05396 16.8107 3.77265C16.5294 3.49135 16.1478 3.33331 15.75 3.33331H3.75C3.35218 3.33331 2.97064 3.49135 2.68934 3.77265C2.40804 4.05396 2.25 4.43549 2.25 4.83331V16.8333C2.25044 16.9744 2.29068 17.1125 2.36608 17.2318C2.44149 17.3511 2.54901 17.4466 2.67629 17.5075C2.80358 17.5684 2.94546 17.5922 3.08564 17.5761C3.22581 17.56 3.3586 17.5046 3.46875 17.4164L6.75 14.7708V17.5833C6.75 17.9811 6.90804 18.3627 7.18934 18.644C7.47064 18.9253 7.85218 19.0833 8.25 19.0833H17.0241L20.5312 21.9164C20.664 22.0238 20.8293 22.0826 21 22.0833C21.1989 22.0833 21.3897 22.0043 21.5303 21.8636C21.671 21.723 21.75 21.5322 21.75 21.3333V9.33331C21.75 8.93549 21.592 8.55396 21.3107 8.27265C21.0294 7.99135 20.6478 7.83331 20.25 7.83331ZM6.23906 13.2502L3.75 15.263V4.83331H15.75V13.0833H6.71063C6.53897 13.0833 6.37252 13.1422 6.23906 13.2502ZM20.25 19.763L17.7609 17.7502C17.6282 17.6428 17.4629 17.584 17.2922 17.5833H8.25V14.5833H15.75C16.1478 14.5833 16.5294 14.4253 16.8107 14.144C17.092 13.8627 17.25 13.4811 17.25 13.0833V9.33331H20.25V19.763Z"
    fill={color}
    strokeWidth={strokeWidth}
    fillOpacity={opacity}
  />
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} opacity={1} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const RCS = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
    viewBox="0 0 24 25"
    fill="none"
  />
));

RCS.displayName = 'RCS';
